/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
//# sourceMappingURL=isDate.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/isDate.js
// module id = 788
// module chunks = 0